const CHUNK_RELOAD_SESSION_KEY = 'adminpanel.chunkLoadReloadAttempted'

export function isChunkLoadError(error) {
  if (!error) return false

  const message = (error.message || String(error)).toLowerCase()
  const name = error.name || ''

  if (name === 'ChunkLoadError') return true
  if (message.includes('loading chunk') || message.includes('chunkloaderror')) {
    return true
  }
  if (message.includes('loading css chunk')) return true
  if (name === 'SyntaxError' && (message.includes('<!doctype') || message.includes('unexpected token'))) {
    return true
  }

  return false
}

function tryRecoverFromChunkLoadError(error) {
  if (!isChunkLoadError(error)) return false

  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
      return false
    }
    sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, String(Date.now()))
  } catch (storageError) {
    // sessionStorage may be unavailable; still attempt one reload.
    console.warn('chunkLoadRecovery: sessionStorage unavailable', storageError)
  }

  window.location.reload()
  return true
}

export function clearChunkLoadReloadFlag() {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY)
  } catch (storageError) {
    console.warn('chunkLoadRecovery: could not clear reload flag', storageError)
  }
}

export function registerChunkLoadRecovery() {
  if (typeof window === 'undefined') return

  window.addEventListener('unhandledrejection', event => {
    if (tryRecoverFromChunkLoadError(event.reason)) {
      event.preventDefault()
    }
  })

  window.addEventListener('error', event => {
    if (tryRecoverFromChunkLoadError(event.error || event.message)) {
      event.preventDefault()
    }
  })
}
